import { render, staticRenderFns } from "./Traduccion.vue?vue&type=template&id=204baf06&lang=pug&"
import script from "./Traduccion.vue?vue&type=script&lang=js&"
export * from "./Traduccion.vue?vue&type=script&lang=js&"
import style0 from "./Traduccion.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports